const o=["ekardo.com","kanzi.io","quickcodes.io"];export{o as NETFRONT_PRODUCT_DOMAIN};
//# sourceMappingURL=useGetProduct.interfaces.js.map
